/* eslint-disable react/no-array-index-key */
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../../../Components/Headings';
import './reviws.css';
import { RightArrowWithBorder } from '../../../../Components/icons';
import { RatingStars } from '../../../../Components/rating';

const reviews = [
  {
    doctorName: 'Prof. Dr. Nadia Khurshid Ahmed',
    status: false,
    rating: 5,
    link: '#1'
  },
  {
    doctorName: 'Prof. Dr. Nadia Khurshid Ahmed',
    rating: 5,
    status: false,
    link: '#2'
  },
  {
    doctorName: 'Prof. Dr. Nadia Khurshid Ahmed',
    rating: 2,
    status: false,
    link: '#3'
  },
  {
    doctorName: 'Prof. Dr. Nadia Khurshid Ahmed',
    rating: 4,
    status: false,
    link: '#4'
  },
  {
    doctorName: 'Prof. Dr. Nadia Khurshid Ahmed',
    rating: 3,
    status: false,
    link: '#5'
  },
  {
    doctorName: 'Prof. Dr. Nadia Khurshid Ahmed',
    rating: 4,
    status: false,
    link: '#6'
  }
];

function Reviws() {
  return (
    <section className="reviwsSec">
      <HeadingWithSpaceLarge text="YOUR REVIEWS" />
      <div className="reviwContainer">
        <div className="firstRow">
          <Row>
            <Col className="col-6" md={5}>
              <div className="customColounm">
                <HeadingDescSmall text="Doctor Appointment " />
              </div>
            </Col>
            <Col className="col-8" md={7}>
              <div className="customColounm">
                <HeadingDescSmall text="Rating Given" />
              </div>
            </Col>
          </Row>
        </div>
        <div className="secondRow">
          {reviews.map((singleReview, index) => {
            const { doctorName, rating, link } = singleReview;
            return (
              <Row key={index}>
                <Col className="col-5" md={5}>
                  <div className="customColounm">
                    <HeadingDescVsmall text={doctorName} />
                  </div>
                </Col>
                <Col className="col-4 px-0" md={4}>
                  <div className="customColounm">
                    <RatingStars newValue={rating} />
                  </div>
                </Col>
                <Col className="col-3" md={3}>
                  <div className="customColounm">
                    <Link to={link} className="arrowAncer">
                      <RightArrowWithBorder />
                      <h6 className="underline_ancer_small">view</h6>
                    </Link>
                  </div>
                </Col>
              </Row>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Reviws;
